import { h } from 'preact';
import Store from 'store/store';
import { backgroundCount } from 'utils/poster';

import Selector from 'components/bolt/quizPhotobooth/selector';

// import s from 'components/bolt/quizPhotobooth/backgroundSelector.sss';

export default class BackgroundSelector extends Selector {
	constructor(props) {
		super(props);
	}

	get titleText() {
		const sides = this.props.cardData.sides;
		const copy = this.props.appData?.copy?.baseCopy;
		if (sides.length < 2) return copy?.$QUIZPHOTOBOOTH_CHOOSE_FRAME;
		return sides.every(side => side.photo) ? copy?.$QUIZPHOTOBOOTH_CHOOSE_FRAME_DUAL_SECOND : copy?.$QUIZPHOTOBOOTH_CHOOSE_FRAME_DUAL_FIRST;
	}

	get currentIndex() {
		return this.props.cardData.sides[this.props.selectedSide]?.background || 0;
	}

	get itemsCount() {
		return backgroundCount;
	}

	confirm() {
		super.confirm();
		Store.emit('TRACK_QUIZPHOTOBOOTH_CHOOSE_FRAME', this.currentIndex + 1);
	}

	select(index) {
		const cardData = { ...this.props.cardData };
		const side = cardData.sides[this.props.selectedSide];
		if (side) {
			side.background = index;
			this.props.updateCardData(cardData);
		}
	}
}